import React, { useEffect, useState } from "react";
import {} from "../../core/feature/store";
import { useAppSelector } from "../../core/feature/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import User from "../../core/models/user";
import "react-multi-carousel/lib/styles.css";
import * as api_info from "../../core/service/api_info";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import { StatsInformasi } from "../common/home/Stats";
import * as API from "../../core/service/api.js";
import { setToken } from "../../core/feature/token/tokenSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import moment from "moment";
import { useTranslation } from "react-i18next";
import banner from "../../assets/images/icon_stock/banner.png";
import Content from "../common/home/Content";
import _ from "lodash";
import { Tooltip, Whisper } from "rsuite";
import CustomApp from "../../core/models/customApp";
import { toast } from "react-toastify";
import { isDarkColor } from "../../config/DarkColorChecker";

const InfoWeb = () => {
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);
  const token: String = useAppSelector((state) => state.token.token);
  const [pages, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [data, setData] = useState<any>([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [tags, setTags] = useState<any>([]);
  const [selectedTags, setSelectedTags] = useState(["info"]);
  const [isAll, setIsAll] = useState(true);
  const [total, setTotal] = useState(0);
  const [size, setSize] = useState(10);
  const { t } = useTranslation();
  const dataTags = JSON.parse(String(localStorage.getItem("tags")));
  const auto = localStorage.getItem("auto_login");
  // const [selected, setSelected] = useState(people[0]);

  const env = Config.BaseUrlDev;

  useEffect(() => {
    if (location.pathname.split("/")[2] != undefined) {
      console.log("AAAA");
      dispatch(setToken(location.pathname.split("/")[2]));
      API.credentialCheck()
        .then((resCredential: any) => {
          console.log(resCredential.data, "fdff");
          dispatch(setUser(resCredential.data.user));
          navigate("/home", { replace: true });
          getData();
          getAllTags();
        })
        .catch((err) => {
          dispatch(removeUser());
          if (auto === "1") {
            login();
          } else {
            navigate("/login", { replace: true });
          }
        });
    } else {
      console.log("BBBB");
      if (user == undefined) {
        if (auto === "1") {
          login();
        } else {
          navigate("/login", { replace: true });
        }
      } else {
        API.credentialCheck()
          .then((resCredential: any) => {
            console.log(resCredential.data, "fdff");
            dispatch(setUser(resCredential.data.user));
            getData();
            getAllTags();
          })
          .catch((err) => {
            dispatch(removeUser());
            if (auto === "1") {
              login();
            } else {
              navigate("/login", { replace: true });
            }
          });
      }
    }
  }, [location.pathname.split("/")[2]]);

  useEffect(() => {
    if (selectedTags.length == 0) {
      setSelectedTags(["info"]);
      setIsAll(true);
    }
    getData();
    console.log(selectedTags, "isi tags");
  }, [selectedTags]);

  const login = async () => {
    var CryptoJS = require("crypto-js");
    var getCredential = localStorage.getItem("credential");

    var bytes = CryptoJS.AES.decrypt(getCredential, "credential");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    var data = decryptedData;

    API.login(data)
      .then((res) => {
        dispatch(setLoading(false));
        dispatch(setToken(res.headers.authorization.replaceAll("Bearer ", "")));
        API.credentialCheck()
          .then((resCredential) => {
            var auto = "1";
            var ciphertext = CryptoJS.AES.encrypt(
              JSON.stringify(data),
              "credential"
            ).toString();
            localStorage.setItem("credential", ciphertext);
            localStorage.setItem("auto_login", auto);
            // var bytes = CryptoJS.AES.decrypt(ciphertext, 'password');
            dispatch(setUser(resCredential.data.user));
          })
          .catch((err: any) => {
            localStorage.setItem("0", "auto_login");

            navigate("/login", { replace: true });
          });
      })
      .catch((err) => {
        dispatch(setLoading(false));
        toast.error(t("LOGIN.wrongLogin"));
      });
  };

  function getData() {
    dispatch(setLoading(true));
    setPage(0);

    var findTags = _.findIndex(selectedTags, function (o) {
      return o == "info";
    });

    if (findTags == 0) {
      var temp = _.concat(selectedTags, dataTags);
      api_info.getInfoNews(pages, temp, size).then((res: any) => {
        dispatch(setLoading(false));
        setData(res.data.content);
        setTotal(res.data.totalElements);
      });
    } else {
      api_info.getInfoNews(0, selectedTags, size).then((res: any) => {
        dispatch(setLoading(false));
        setData(res.data.content);
        setTotal(res.data.totalElements);
      });
    }
  }

  const changePage = (newPage: any) => {
    setPage(newPage);
    dispatch(setLoading(true));

    var findTags = _.findIndex(selectedTags, function (o) {
      return o == "info";
    });

    if (findTags == 0) {
      var temp = _.concat(selectedTags, dataTags);
      api_info.getInfoNews(newPage, temp, size).then((res: any) => {
        dispatch(setLoading(false));
        setData(res.data.content);
        setTotal(res.data.totalElements);
      });
    } else {
      api_info.getInfoNews(newPage, selectedTags, size).then((res: any) => {
        dispatch(setLoading(false));
        setData(res.data.content);
        setTotal(res.data.totalElements);
      });
    }
  };

  const changeSize = (newSize: any) => {
    setSize(newSize);
    dispatch(setLoading(true));

    var findTags = _.findIndex(selectedTags, function (o) {
      return o == "info";
    });

    if (findTags == 0) {
      var temp = _.concat(selectedTags, dataTags);
      api_info.getInfoNews(pages, temp, newSize).then((res: any) => {
        dispatch(setLoading(false));
        setData(res.data.content);
        setTotal(res.data.totalElements);
      });
    } else {
      api_info.getInfoNews(pages, selectedTags, newSize).then((res: any) => {
        dispatch(setLoading(false));
        setData(res.data.content);
        setTotal(res.data.totalElements);
      });
    }
  };

  function openModal(item: any) {
    // setIsOpen(true);
    navigate("/info-detail/" + item._id, { replace: true });
  }

  function check(temp: any) {
    setSelectedTags(temp);
    console.log(temp);
    setTimeout(() => {
      console.log(selectedTags);
    }, 1000);
  }

  function setSelectAll() {
    setIsAll(true);
    let temp = ["info"];
    clearData();
    setPage(0);
    setSelectedTags(temp);
  }

  function setSelected(tag: any) {
    /**
     * ketika selectedTags includes tag ? hapus tag tsb :
     * add tag
     */
    console.log(tag);
    setIsAll(false);
    let temp: any = [];
    temp = !isAll ? selectedTags : [];

    if (selectedTags.includes(tag)) {
      removeItem(tag);
    } else {
      setSelectedTags([...selectedTags, tag]);
      temp.push(tag);
    }
    console.log(temp);
    console.log(selectedTags);
    clearData();
    setPage(0);
  }

  function clearData() {
    setData([]);
  }

  function removeItem(tag: any) {
    var array = [...selectedTags];
    var index = array.indexOf(tag);
    if (index !== -1) {
      array.splice(index, 1);
      setSelectedTags(array);
    }
  }

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  function getYtCode(str: String) {
    var regExp =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = str.match(regExp);
    let x = "";
    if (match && match[2].length == 11) {
      x = match[2];
    } else {
      //error
    }
    return String(x)
      .replace("/", "")
      .replace("v=", "")
      .replace("?", "")
      .replace("#", "");
  }

  // const selectTab = async (item: any) => {
  //   if (item != "all") {
  //     setIsAll(false);
  //     var evens2 = _.remove(selectedTags, function (n) {
  //       return n != "info";
  //     });
  //     if (evens2.includes(item)) {
  //       var evens = _.remove(evens2, function (n) {
  //         return n != item;
  //       });

  //       setSelectedTags(evens);
  //     } else {
  //       setSelectedTags([...evens2, item]);
  //     }
  //   } else {
  //     setSelectedTags(["all"]);
  //     setIsAll(true);
  //   }
  //   console.log(item);
  // };

  const selectTab = async (item: any) => {
    if (item != "all") {
      setIsAll(false);
      var evens2 = _.remove(selectedTags, function (n) {
        return n != "info";
      });
      if (evens2.includes(item)) {
        var evens = _.remove(evens2, function (n) {
          return n != item;
        });

        setSelectedTags(evens);
      } else {
        setSelectedTags([...evens2, item]);
      }
    } else {
      setSelectedTags(["info"]);
      setIsAll(true);
    }
  };

  function getAllTags() {
    let temp = JSON.parse(String(localStorage.getItem("tags")));
    setTags(temp);
    console.log(temp, "temp");
  }

  return (
    <div className="bg-psp-primary mb-8 pb-20 font-montserrat">
      <StatsInformasi />
      <div className="container relative w-full -mt-44 bg-white shadow rounded-2xl pb-10">
        <div className="justify-center h-full w-full">
          <div className="flex w-full mt-3">
            <h1 className="text-4xl mt-3 ml-3 font-bold">
              {t("BERITA.title")}
            </h1>
          </div>
          <div className="flex ml-4">
            <span className="text-slate-400 text-2xl">Tags</span>
          </div>
          <div className="overflow-x-auto w-auto my-3 mb-4 ">
            <button
              onClick={() => selectTab("all")}
              style={
                isAll
                  ? {
                      backgroundColor: customApp?.app_accent_color,
                      color: isDarkColor(customApp?.app_accent_color)?'white':'black',
                    }
                  : {
                      backgroundColor:
                        "rgb(203 213 225 / var(--tw-bg-opacity))",
                      color: "grey",
                    }
              }
              className="px-3 ml-2 mb-2 rounded-md py-2"
              // className={
              //   isAll
              //     ? "bg-psp-btn-primary px-3 rounded-md ml-5 text-white"
              //     : "bg-slate-300 py-2 ml-5 rounded-md text-slate-100 px-3"
              // }
            >
              Semua
            </button>
            {tags.map((item: any) => {
              return (
                <button
                  onChange={() => selectTab(item)}
                  onClick={() => selectTab(item)}
                  style={
                    selectedTags.includes(item)
                      ? {
                          backgroundColor: customApp?.app_accent_color,
                          color: isDarkColor(customApp?.app_accent_color)?'white':'black',
                        }
                      : {
                          backgroundColor:
                            "rgb(203 213 225 / var(--tw-bg-opacity))",
                          color: "grey",
                        }
                  }
                  className="px-3 py-2 mb-2 rounded-md ml-2"
                >
                  {item}
                </button>
              );
            })}
          </div>
          <div className="ml-5 mt-2 flex mb-4">
            <span className="text-slate-400 text-2xl">
              {t("BERITA.subtitle")}
            </span>
          </div>
          <div className="container">
            {data.length < 1 ? (
              <div className="text-center">
                <span>{t("OTHER.dataNotFound")}</span>
              </div>
            ) : (
              <div className="flex flex-row flex-wrap relative w-full">
                {data.map((item: any, index: any) => (
                  <div
                    key={index}
                    className="bg-white mb-8 cursor-pointer relative flex w-1/4"
                    onClick={() => {
                      openModal(item);
                    }}
                  >
                    <div className="bg-containe bg-no-repeat hover:bg-blue-50 border rounded-xl w-full h-full mx-2 shadow-md">
                      {item.imageOpt.length > 0 && !item.image && (
                        <img
                          src={getImgContent(item.imageOpt[0])}
                          alt=""
                          className="rounded-t-lg w-full h-[220px]"
                        />
                      )}

                      {item.imageOpt.length < 1 && item.image && (
                        <img
                          src={getImgContent(item.image)}
                          alt=""
                          className="rounded-t-lg w-full h-[220px]"
                        />
                      )}
                      {item.imageOpt.length > 0 && item.image && (
                        <img
                          src={getImgContent(item.image)}
                          alt=""
                          className="rounded-t-lg w-full h-[220px]"
                        />
                      )}

                      {item.imageOpt.length == 0 &&
                        item.image == "" &&
                        item.videoUrl == "" && (
                          <img
                            className="rounded-t-lg w-full h-[220px]"
                            alt=""
                            src={banner}
                          />
                        )}
                      {item.imageOpt.length == 0 &&
                        !item.image &&
                        item.videoUrl && (
                          <img
                            src={`https://img.youtube.com/vi/${getYtCode(
                              item.videoUrl
                            )}/sddefault.jpg`}
                            alt=""
                            className="rounded-t-lg w-full h-[220px] "
                          />
                        )}
                      <div className="py-3 px-4">
                        <Whisper
                          className="font-montserrat relative flex flex-wrap bg-white font-medium text-left text-psp-nav text-[10px] ml-2 mt-1"
                          followCursor
                          speaker={
                            <Tooltip className="bg-pink-600">
                              {item.title}
                            </Tooltip>
                          }
                        >
                          <h1 className="text-xl font-bold text-black bottom-46 text-left m-0">
                            {item.title.length > 30
                              ? `${item.title.substring(0, 30)}...`
                              : item.title}
                          </h1>
                        </Whisper>
                        <h1 className=" m-0 text-lg font-normal text-slate-400">
                          {moment(item.updateTime).format("DD MMMM YYYY")}
                        </h1>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="flex relative mt-10 justify-between">
              <div className="pt-2 w-1/4">
                <p>
                  {t("OTHER.showing")} {pages + 1} {t("OTHER.to")} {size}{" "}
                  {t("OTHER.from")} {total} {t("OTHER.en")}
                </p>
              </div>
              <div className="w-auto">
                <div className="">
                  <select
                    onChange={(value) => {
                      changeSize(value.target.value);
                    }}
                    value={size}
                    className="py-2 border rounded-lg bg-white"
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={1000}>1000</option>
                  </select>
                  <span className="ml-1">{t("OTHER.entry")}</span>
                </div>
              </div>
              <div className="flex w-1/4">
                <button
                  onClick={() => changePage(pages - 1)}
                  disabled={pages === 0}
                  className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                >
                  {t("OTHER.previous")}
                </button>
                <button
                  onClick={() => changePage(pages + 1)}
                  disabled={(pages + 1) * size > total}
                  className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                >
                  {t("OTHER.next")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoWeb;
